module.exports = __webpack_public_path__ + "img/logo-full.09f31a4f.svg";